<template lang="pug">
	.web-service--base-parameter-selector.flex-col(v-if="param")
		template(v-if="isComplex")
			.font-small.upper.grey(v-if="!hideCaption") {{param.Caption || param.Name}}
			.flex-row.space.flex-1.align-center
				.flex-col.center.full-width(v-if="hasUsedComplexParamValue(param)")
					.flex-row.space.align-center
						.flex-row
							.used-param.disabled-controls.text-overflow.nowrap {{getComplexParametersValues(param).join(' ')}}
						.web-service-param-button.flex-row.align-center(@click="clearParam(param, true)")
							fas(icon="times", size="xs")
				template(v-else)
					.flex-row.flex-1
						.flex-row.space.flex-1
							ComplexParameterSelector.flex-1(:type="param.Type", :name="param.Caption || param.Name", @change="v => onComplexParameterChange(param, v)", :value="getComplexParamValue(param)")
							.is-required(v-if="requiredCustomIds[`complexParam_${param.Id}`]", :title="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
								fas(icon="circle-exclamation")
						.hidden
							dx-validator(:adapter="getCustomValidationAdapter(`complexParam_${param.Id}`, (e) => $set(requiredCustomIds, `complexParam_${param.Id}`, !e.isValid))")
								dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || hasComplexParamValue(param) || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
				slot
		template(v-else-if="hasParentService")
			.font-small.upper.grey(v-if="!hideCaption && !fullStructure") {{param.Caption || param.Name}}
			.flex-row.space.flex-1.align-start
				.flex-row.align-center.full-width(v-if="hasUsedParamValue(paramValues[param.Name])")
					.flex-row.space.align-center
						.flex-row
							.used-param.disabled-controls.text-overflow.nowrap {{paramValues[param.Name]}}
						.web-service-param-button.flex-row.space.align-center(@click="clearParam()")
							fas(icon="times", size="xs")
				template(v-else)
					.flex-row.flex-1
						.flex-row.space.flex-1
							full-structure-parameter-selector.flex-1(v-if="fullStructure", :parameter="param", :paramValues="paramValues", :paramCaptions="paramCaptions", @change="onFullStructureParamChange")
							ParentServiceParam.flex-1(v-else, :serviceId="param.ParentServiceOid", :name="param.Caption || param.Name", :serviceOutputName="param.ParentServiceOutput", :value="paramValues[param.Name]", :caption="paramCaptions[param.Name]",
								@change="(key, item, params, paramsCaptions, propagatedEditableParams) => onParentParamChange(param, key, item, params, paramsCaptions, propagatedEditableParams)")
							.is-required(v-if="requiredCustomIds[`baseServiceParam_${param.Name}`]", :title="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
								fas(icon="circle-exclamation")
						.hidden
							dx-validator(:adapter="getCustomValidationAdapter(`baseServiceParam_${param.Name}`, (e) => $set(requiredCustomIds, `baseServiceParam_${param.Name}`, !e.isValid))")
								dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || paramValues[param.Name] != null || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
				slot
		template(v-else)
			.font-small.upper.grey(v-if="!hideCaption && ['boolean'].indexOf(param.DataType) === -1") {{param.Caption || param.Name}}
			.flex-row.space.align-center
				.flex-row.align-center.full-width(v-if="hasUsedParamValue(paramValues[param.Name])")
					.flex-row.space.align-center
						.flex-row
							.used-param.disabled-controls.text-overflow.nowrap {{paramValues[param.Name]}}
						.web-service-param-button.flex-row.space.align-center(@click="clearParam()")
							fas(icon="times", size="xs")
				template(v-else)
					DxTextBox.flex-1(v-if="param.DataType === 'string' && !param.IsMemo", :value.sync="paramValues[param.Name]", @value-changed="() => emitChange()", valueChangeEvent="input", stylingMode="filled")
						dx-validator
							dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || (paramValues[param.Name] != null && paramValues[param.Name] !== '') || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Name)")
					DxTextArea.flex-1(v-if="param.DataType === 'string' && param.IsMemo", :value.sync="paramValues[param.Name]", @value-changed="() => emitChange()", valueChangeEvent="input", stylingMode="filled", :height="120")
						dx-validator
							dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || (paramValues[param.Name] != null && paramValues[param.Name] !== '') || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Name)")
					template(v-if="param.DataType === 'date'",)
						.flex-row.space.flex-1.align-center
							ServiceDateEditor.flex-1(:value="getParamValue(param)", :defaultValue="defaultValue", @change="v => onDateParamChanged(param, v)", :hasTimeZone="!param.UseTargetTimeZone", :hasTime="param.AllowTime")
							.is-required(v-if="requiredCustomIds[`param_${param.Name}`]", :title="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
								fas(icon="circle-exclamation")
						.hidden
							dx-validator(:adapter="getCustomValidationAdapter(`param_${param.Name}`, (e) => $set(requiredCustomIds, `param_${param.Name}`, !e.isValid))")
								dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || paramValues[param.Name] != null || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Caption || param.Name)")
					DxNumberBox.flex-1(v-if="param.DataType === 'number'", :value.sync="numberValue", :show-spin-buttons="true", :show-clear-button="true", @value-changed="() => emitChange()", 
						valueChangeEvent="input", stylingMode="filled")
						dx-validator
							dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || paramValues[param.Name] != null || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Name)")
					DxSelectBox.flex-1(v-if="param.DataType === 'list' && !param.MultiSelect", :items="param.ListOptions && param.ListOptions.map(f => ({ key: f.Key, value: f.Value || f.Key }))", value-expr="key", display-expr="value", :search-enabled="false", 
						:value="paramValues[param.Name]", @item-click="e => onListValueChanged(param, e)", stylingMode="filled")
						dx-validator
							dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || paramValues[param.Name] != null || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Name)")
					DxTagBox.flex-1.compact(v-if="param.DataType === 'list' && param.MultiSelect", :data-source="param.ListOptions && param.ListOptions.map(f => ({ key: f.Key, value: f.Value || f.Key }))", value-expr="key", display-expr="value",
						stylingMode="filled", :multiline="false", :maxDisplayedTags="2", :height="40", :value.sync="multiSelectValues", @item-click="e => onListValueChanged(param, e)")
						dx-validator
							dx-custom-rule(:reevaluate="true", :validation-callback="() => !param.IsRequired || paramValues[param.Name] != null || !checkValidation", :message="$tCaption('PARAM_NAME is required').replace(/PARAM_NAME/g, param.Name)")
					.flex-col.space(v-if="param.DataType === 'boolean'")
						.vertical-space
						DxCheckBox.flex-1(:text="param.Name", :value="getParamValue(param)", @value-changed="(e) => { paramValues[param.Name] = e.value; emitChange() }", stylingMode="filled")
				slot
</template>

<script>
	import _ from 'lodash';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTagBox from 'devextreme-vue/tag-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
	import ParentServiceParam from './ParentServiceParam.vue';
	import serviceHelper from './service-helper';
	import ComplexParameterSelector from './ComplexParameterSelector.vue';
	import ServiceDateEditor from './ServiceDateEditor.vue';

	export default {
		translationCategory: 'webServiceCaller.StructureBuilder',
		name: 'web-service--complex-parameter-selector',
		components: { 
			DxTextBox, DxDateBox, DxNumberBox, DxSelectBox, DxCheckBox, DxValidationGroup, DxValidator, DxRequiredRule, DxCustomRule, ParentServiceParam,
			ComplexParameterSelector, ServiceDateEditor, DxTagBox, DxTextArea
		},
		model: {
		},
		props: ['parameter', 'paramResolver', 'paramValues', 'paramCaptions', 'defaultValue', 'checkValidation', 'propagatedEditableParams', 'hideCaption', 'fullStructure'],
		data() {
			return {
				dateDropDownOptions: {
					toolbarItems: [
						{
							widget: 'dxButton',
							toolbar: 'bottom',
							location: 'center',
							options: {
								text: () => this.$tCaption('Today'),
								onClick: () => {
									this.$refs.datebox[0].instance.option('value', new Date());
									this.$refs.datebox[0].instance.close();
								}
							}
						}
					]
				},
				requiredCustomIds: {},
				param: this.parameter,
			};
		},		
		computed: {
			isComplex() {
				return !!this.param?.Keys;
			},
			hasParentService() {
				return this.param.ParentServiceOid;
			},
			numberValue: {
				get: function() { return parseFloat(this.paramValues[this.param.Name]) || 0 },
				set: function(v) { this.paramValues[this.param.Name] = v },
			},
			multiSelectValues: {
				get: function() {
					let v = (this.paramValues[this.param?.Name] || '');
					if (!v) return [];
					return v?.split && v.split(',').map(f => (f || '').trim()).filter(f => f) || [v];
				},
				set: function() {
				},
				cache: false
			}
		},
		watch: {
			parameter(v) {
				this.param = v;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.baseParamSelector = this;
			this.resolveParam();
		},		
		destroyed() {
			delete this.$listValueChanging;
		},
		methods: {
			getComplexParametersValues(param) {
				return param.Keys.map(f => this.paramValues[`${param.Name}_${f}`]).filter(f => f);
			},
			onFullStructureParamChange(values, captions) {
				if (__DEBUG__)
					console.debug('onFullStructureParamChange', { values, captions });

				if (values)
					Object.keys(values).map(key => {
						this.$set(this.paramValues, key, values[key]);
					});

				if (captions)
					Object.keys(captions).map(key => {
						this.$set(this.paramCaptions, key, captions[key]);
					});
					
				this.emitChange();
			},
			async resolveParam() {
				if (this.paramResolver && !this.parameter) {
					this.$set(this, 'param', await this.paramResolver());
				}
				if (__DEBUG__)
					window[`baseParameterSelector_${this.param?.Name}`] = this;
			},
			clearParam() {
				this.$emit('clear')
			},
			emitChange() {
				this.$emit('change', this.paramValues, this.paramCaptions);
			},
			getParamValue(param) {
				if (param.DataType === 'boolean') {
					return `${this.paramValues[param.Name]}`.toLowerCase() === 'true';
				}

				return this.paramValues[param.Name];
			},
			hasUsedParamValue(text) {
				return `${text}`.match(/\[(.*?)@(.*?)\]/g)?.length || `${text}`.match(/\[!(.*?)\]/g)?.length;
			},
			onDateParamChanged(param, v) {
				this.paramValues[param.Name] = v || this.default;
				if (this.paramCaptions[param.Name]) delete this.paramCaptions[param.Name];
				this.emitChange();
			},
			onListValueChanged(param, e) {
				if (__DEBUG__)
					console.debug('onListValueChanged', { param, e });
				if (this.$listValueChanging) return;
				
				this.$listValueChanging = true;
				if (!e.addedItems) {
					if (!e.selectedItem) {
						e.selectedItem = e.itemData;
					}
					e.addedItems = [e.itemData];
					e.removedItems = [];
				}
				try {
					if (param?.MultiSelect) {
						const changes = [...e.addedItems.map(f => f.key), ...e.removedItems.map(f => f.key)];
						const arr = [...this.multiSelectValues];
						changes.map(key => this.$Data.toggleSelectedIdInArray(key, arr));
						if (arr.join(',') !== this.paramValues[this.param?.Name]) {
							this.$set(this.paramValues, this.param?.Name, arr.join(','));
							this.emitChange();
						}
						return;
					}
					if (e.selectedItem?.key != this.paramValues[param.Name]) {
						this.$set(this.paramValues, param.Name, e.selectedItem?.key);
						if (e.selectedItem?.value) {
							this.$set(this.paramCaptions, param.Name, e.selectedItem?.value);
						}
						this.emitChange();
					}
				} finally {
					this.$nextTick(() => this.$nextTick(() => this.$listValueChanging = false))
				}
			},
			valueResolver(param, value) {
				return this.$Data.externalServiceGetParamValue(param, value);
			},
			async onParentParamChange(param, key, selectedItem, parentParams, parentParamsCaptions, propagatedEditableParams) {
				_.assign(this.propagatedEditableParams, propagatedEditableParams);
				this.$set(this.paramValues, param.Name, key);
				this.$set(this.paramCaptions, param.Name, selectedItem?.Value);

				const editableParameters = await serviceHelper.getParentEditableParameters(param, []);
				
				if (parentParams) {
					editableParameters.map(paramName => {
						if (parentParams[paramName])
							this.paramValues[paramName] = parentParams[paramName];
						if (parentParamsCaptions && parentParamsCaptions[paramName])
							this.paramCaptions[paramName] = parentParamsCaptions[paramName];
					})
				}

				this.emitChange();

				if (__DEBUG__)
					console.debug('onParentParamChange', { parentParams, np: this.paramValues, caps: this.paramCaptions, propagatedEditableParams, editableParameters });
			},
			getCustomValidationAdapter(name, applyValidationResults) {
				if (!this.$validationCallbacks)
					this.$validationCallbacks = [];
				if (!this.$customValidationAdapter)
					this.$customValidationAdapter = {};
				if (!this.$customValidationAdapter[name]) {
					this.$customValidationAdapter[name] = {
						getValue: () => null,
						applyValidationResults: (e) => {
							if (__DEBUG__)
								console.debug('applyValidationResults', { e });
							applyValidationResults(e);
						},
						validationRequestsCallbacks: this.$validationCallbacks
					}
				}
				return this.$customValidationAdapter[name];
			},
			hasUsedComplexParamValue(param) {
				return param.Keys.some(f => this.hasUsedParamValue(this.paramValues[`${param.Name}_${f}`]));
			},
			onComplexParameterChange(param, v) {
				if (!param) return;
				(param?.Keys || []).map(key => {
					this.$set(this.paramValues, `${param.Name}_${key}`, v[key]);
				});

				if (__DEBUG__)
					console.debug('On complex param change', { param, v, vals: this.paramValues });

				this.emitChange();
			},
			getComplexParamValue(param) {
				return (param?.Keys || []).reduce((res, key) => {
					res[key] = this.paramValues[`${param.Name}_${key}`];
					return res;
				}, {});
			},
			hasComplexParamValue(param) {
				const hasValue = (param?.Keys || []).some(key => this.paramValues[`${param.Name}_${key}`]);
				if (__DEBUG__)
					console.debug('hasComplexParamValue', { param, v: this.paramValues, hasValue });
				return hasValue;
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.web-service--base-parameter-selector {
		.dx-texteditor-input-container.dx-tag-container {
			padding: 0px 4px 4px !important;
			min-height: 41px !important;

			.dx-tag {
				margin: 4px 4px 0 0 !important;
			}
		}
	}
</style>
